var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.classNames, { disabled: _vm.disabled }],style:({ 'background-color': _vm.bgColor }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("suplabel"),_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.getLabel())+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }